module.exports = __webpack_public_path__ + "static/fast-skeleton-elements-2e9412047a00beeee8230a53c1bef7a8.png";